import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';

export const TimelineWrapper = styled.div<{
    accentColor: AccentColorOptions;
    cycle: number;
    activeIndustry: string;
}>`
    position: absolute;
    bottom: 100px;
    left: 0;
    width: 100vw;
    z-index: 88;
    transition: all 0.2s ease;
    text-align: center;
    opacity: 1;
    &:not(.inView) {
        pointer-events: none;
    }

    && {
        &.inUniverse {
            li.active {
                .linewrapper .progress {
                    width: 100%;
                }
            }

            li .label.inUniverse {
                color: ${(p) => p.theme.palette.neutral.silver};
            }
        }
    }

    li.active .linewrapper .progress {
        width: ${(p) => p.cycle}%;
    }

    ul {
        list-style: none;
        margin: 0 auto;
        padding: 0;
        text-align: center;
        width: 100%;
    }

    li,
    li .linewrapper,
    li .linewrapper .track {
        width: 200px;
        ${(p) => p.theme.breakpoints.down('lg')} {
            width: 175px;
        }
        ${(p) => p.theme.breakpoints.down('md')} {
            width: 130px;
        }
    }

    li {
        display: inline-block;
        height: 65px;
        position: relative;
        margin: 0;

        &.active,
        &:hover {
            .label {
                color: ${(p) => p.theme.palette.common.white};
            }
            .dot {
                transform: scale(2);
            }
        }

        &.passed,
        &.active {
            .dot,
            .progress {
                background: ${(p) => p.theme.palette.accent[p.accentColor]};
            }
        }

        &.active {
            .progress {
                transition: width 1000ms linear;
            }

            .linewrapper.dontAnimate {
                && {
                    .progress {
                        transition: 0s ease;
                    }
                }
            }

            &.filled {
                + li {
                    .dot {
                        background: ${(p) => p.theme.palette.accent[p.accentColor]};
                        transform: scale(2);
                    }
                }
            }
        }

        &.passed {
            .linewrapper .progress {
                width: 100%;
                transition: 0s ease;
            }
        }

        &.more {
            width: 10px;
            .linewrapper {
                display: none;
            }
        }

        button {
            position: relative;
            background: none;
            display: block;
            border: 0;
            color: #fff;
            outline: none;
            padding: 10px;
            font-family: arial;
            text-transform: uppercase;
            transition: 0.3s ease;
            transform-origin: center center;
            cursor: pointer;
            margin: 0;
            .dot {
                position: absolute;
                top: 20px;
                left: 0;
                width: 9px;
                height: 9px;
                background: ${(p) => p.theme.palette.common.white};
                border-radius: 9999px;
                display: block;
                transition: 0.3s ease;
                z-index: 2;
            }
            .label {
                position: absolute;
                bottom: -105px;
                left: -65px;
                width: 150px;
                height: 60px;
                text-align: center;
                vertical-align: top;
                color: ${(p) => p.theme.palette.neutral.silver};
                text-align: center;
                letter-spacing: 3px;
                ${(p) => p.theme.breakpoints.down('md')} {
                    h4 {
                        width: 125px;
                        letter-spacing: 2px;
                        line-height: 16px;
                        font-size: 11px;
                    }
                }
            }
        }

        .linewrapper {
            display: block;
            height: 3px;
            top: 22px;
            position: absolute;
            z-index: 1;
            .progress {
                height: 3px;
                position: absolute;
                top: 1px;
                left: 0;
                width: 0;
                z-index: 2;
            }
            .track {
                position: absolute;
                top: 2px;
                left: 0;
                height: 1px;
                z-index: 1;
                background: ${(p) => p.theme.palette.neutral.silver};
            }
        }
    }
`;
